import { type ComponentType, lazy } from 'react';

type Factory<T extends ComponentType<any>> = () => Promise<{ default: T }>;

export function lazyWithPreload<T extends ComponentType<any>>(factory: Factory<T>) {
  const Component = lazy(factory) as unknown as ReturnType<typeof lazy> & {
    preload: () => Promise<void>;
  };

  let preloadPromise: Promise<void> | null = null;

  Component.preload = () => {
    if (!preloadPromise) {
      preloadPromise = factory().then(() => void 0);
    }
    return preloadPromise;
  };

  return Component;
}
